import CollectorComment from "../../CollectorComment/CollectorComment";
import { useBigProductCardPickerComment } from "./useBigProductCardPickerComment";

interface Props {
  ean: string;
}
const BigProductCardPickerComment = ({ ean }: Props) => {
  const props = useBigProductCardPickerComment(ean);
  return <CollectorComment {...props} bigFont />;
};

export default BigProductCardPickerComment;
